module.exports = __webpack_public_path__ + "static/media/legal.fd378d1c.svg";